export const randFromArray = (array = []) =>
  array[Math.floor(Math.random() * array.length)];
